import styled from "styled-components";
import { primaryColor } from "utils/form-constants";

export const SecuritiesContainer = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: "28px",
});

export const SecurityItemHeader = styled.div({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: "16px",

  "& > span": {
    fontWeight: 600,
    fontSize: "18px",
  },
});

export const RemoveSecurityButton = styled.button({
  background: "none",
  border: "none",
  color: primaryColor,
  cursor: "pointer",
  fontSize: "16px",
  fontWeight: 500,

  "&:hover": {
    textDecoration: "underline",
  },

  "&:focus-visible": {
    outline: "solid #333 3px",
  },
});

export const AddSecurityButton = styled.button({
  background: "none",
  color: "#575757",
  cursor: "pointer",
  fontSize: "18px",
  fontWeight: 700,
  border: "none",
  width: "fit-content",

  "&:focus-visible": {
    outline: "solid #333 3px",
  },
});

export const DisclaimerText = styled.p({
  fontSize: "16px",
  color: "#575757",
});
